const navItems = [
    {
        id: "101",
        title: "ABOUT",
        isActive: false,
        url: "#about"
    },
    {
        id: "102",
        title: "PARTNERS",
        isActive: false,
        url: "#partners"
    },
    {
        id: "103",
        title: "ADVISORS",
        isActive: false,
        url: "#advisors"
    },
    {
        id: "104",
        title: "PRESS",
        isActive: false,
        url: "#press"
    },
    {
        id: "105",
        title: "CONTACT",
        isActive: false,
        url: "#contact"
    }
];

export default navItems;